
import Vue from 'vue';
import ModalPortal from '../Modal/ModalPortal.vue';
import WebText from '../Text/Text.vue';
import EButton from '../Button/Button.vue';
import { Padder } from '../Spacings';
/**
 * > A deprecated version of Tray V1
 */
export default Vue.extend<any, any, any, any>({
  name: 'NewTray',
  components: {
    ModalPortal,
    Padder,
    WebText,
    EButton
  },
  model: {
    prop: 'active',
    event: 'change'
  },
  props: {
    /**
     * The tray is active or not.
     * (Connected to v-model)
     */
    active: {
      type: Boolean,
      required: true
    },
    /**
     * The list of option when you create for Select list.
     * The options must contain: <br/>
     * 1. id: number <br/>
     * 2. title: string <br/>
     * 3. content: string <br/>
     * 4. descriptions: array of object. Will show the detail of each option if exist.<br/>
     * a. icon: string url (optional) <br/> 
     * b. text: string (required)
     */
    options: {
      type: Array,
      default: () => []
    },
    /**
     * The title of Tray
     */
    title: {
      type: String
    },
    /**
     * To center the title
     */
    centeringTitle: {
      type: Boolean,
      default: true
    },
    /**
     * To make the buttons flow vertically
     */
    verticalButtons: {
      type: Boolean,
      default: false
    },
    /**
     * It makes has 'Done' and 'Close' button
     * When it has multiple selection.
     */
    multipleSelect: {
      type: Boolean,
      default: false
    },
    /**
     * Primary button type, refer to Button Component
     */
    primaryButtonType: {
      type: String,
      default: 'outline-primary'
    },
    /**
     * Secondary button type, refer to Button Component
     */
    secondaryButtonType: {
      type: String,
      default: 'secondary'
    },
    /**
     * Primary button text.
     */
    primaryButtonText: {
      type: String,
      default: 'Done'
    },
    /**
     * Secondary button text.
     */
    secondaryButtonText: {
      type: String,
      default: 'Close'
    },
    /**
     * To disable Primary button
     */
    primaryDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * To disable Secondary button
     */
    secondaryDisabled: {
      type: Boolean,
      default: false
    },
    /**
     * Callback when value is only one
     */
    onValuePressed: {
      type: Function,
      default: () => {}
    },
    /**
     * Callback to close the tray
     */
    onClose: {
      type: Function,
      default: () => {}
    },
    /**
     * Disabled force close on primary
     */
    disabledClosePrimary: {
      type: Boolean,
      default: false
    },
    /**
     * Disabled force close on secondary
     */
    disabledCloseSecondary: {
      type: Boolean,
      default: false
    },
    /**
     * Set tray radius
     */
    trayRadius: {
      type: String
    },
    /**
     * Set tray always open
     */
    stickTray: {
      type: Boolean,
      default: false
    },
    /**
     * Hide action button on the tray
     */
    hideActionButton: {
      type: Boolean,
      default: false
    },
    /**
     * Make tray stays open when selection is clicked
     * Closes when done/cancel button is clicked
     */
    disableAutoClose: {
      type: Boolean,
      default: false
    },
    /**
     * Make tray opens from top
     */
    topTray: {
      type: Boolean,
      default: false
    },
    /**
     * To show the detail box after select
     */
    isShowDetail: {
      type: Boolean,
      default: false
    }
  },
  created() {
    this.selectedValue = this.multipleSelect ? {} : -1;
  },
  computed: {
    containerClasses() {
      return {
        active: this.activeState,
        'top-tray': this.topTray
      };
    },
    activeState() {
      if (this.stickTray) {
        return true;
      }
      return this.active;
    },
    radiusStyle() {
      if (this.trayRadius) {
        return {
          borderTopRightRadius: `${this.trayRadius}px`,
          borderTopLeftRadius: `${this.trayRadius}px`
        };
      }
      return {};
    }
  },
  data() {
    return {
      selectedValue: null
    };
  },
  methods: {
    isSelected(index: number) {
      const isMultipleSelect = this.multipleSelect && this.selectedValue[index];
      const isSingleSelect = this.disableAutoClose && this.selectedValue === index;
      return isMultipleSelect || isSingleSelect;
    },
    handleSelectBox(index: number) {
      const selectedValue = this.selectedValue;
      if (this.multipleSelect) {
        if (selectedValue[index] === undefined) {
          selectedValue[index] = false;
        }
        selectedValue[index] = !selectedValue[index];
        this.selectedValue = selectedValue;
        this.$forceUpdate();
      } else {
        this.selectedValue = index;
        if (typeof this.onValuePressed === 'function' && !this.disableAutoClose) {
          this.onValuePressed(this.options[index]);
        }
      }
      /**
       * Handle when value is selected
       * @event change
       * @type {function}
       */
      this.$emit('change', this.multipleSelect || this.disableAutoClose);
    },
    handleCloseSecondary() {
      /**
       * Handle close the tray
       * @event on-close
       * @type {function}
       */
      this.$emit('on-close', 'secondary');
      if (!this.disabledCloseSecondary) {
        this.$emit('change', false);
      }
    },
    handleButtonPressed() {
      this.$emit('on-close', 'primary');
      let selectedValue: any[] = [];
      Object.keys(this.selectedValue).forEach((index: string) => {
        if (this.selectedValue[index]) {
          selectedValue.push(this.options[index]);
        }
      });

      if (this.multipleSelect) {
        this.onValuePressed(selectedValue);
      }

      if (!this.disabledClosePrimary) {
        this.$emit('change', false);
      }

      if (this.disableAutoClose) {
        this.onValuePressed(this.options[this.selectedValue]);
      }
    },
    handleClose() {
      this.$emit('on-close');
      this.$emit('change', false);
    }
  }
});
